import {
  IAttachmentData,
  IPaymentRequisitionCommentData,
  IPaymentRequisitionData,
  IPaymentRequisitionLineData,
  PaymentRequisitionFilterParams,
  PaymentRequisitionStatusEnum
} from '@/models';
import { Transition } from '@/models/transition';
import { IUserData } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData.types';

export interface IPaymentRequisitionPaginatedListData {
  count: number;
  next?: string;
  previous?: string;
  results: IPaymentRequisitionData[];
}

export interface IPaymentRequisitionExportFilterParams
  extends PaymentRequisitionFilterParams {
  search?: string;
}

export interface IPaymentRequisitionFilterParam
  extends PaymentRequisitionFilterParams {
  page?: number;
  search?: string;
}

export interface IPaymentRequisitionService {
  fetchPaymentRequisitions(
    filter?: IPaymentRequisitionFilterParam
  ): Promise<IPaymentRequisitionPaginatedListData>;
  fetchPaymentRequisition(id: number): Promise<IPaymentRequisitionData>;
  createPaymentRequisition(
    data: IPaymentRequisitionData
  ): Promise<IPaymentRequisitionData>;
  updatePaymentRequisition(
    data: IPaymentRequisitionData
  ): Promise<IPaymentRequisitionData>;
  deletePaymentRequisition(id: number): Promise<any>;
  updatePaymentRequisitionLine(
    paymentRequisitionId: number,
    data: IPaymentRequisitionLineData
  ): Promise<IPaymentRequisitionLineData>;

  deletePaymentRequisitionAttachment(
    paymentRequisitionId: number,
    attachmentId: number
  ): Promise<any>;
  updatePaymentRequisitionState(
    id: number,
    state: PaymentRequisitionStatusEnum,
    assignee?: number,
    comment?: string
  ): Promise<IPaymentRequisitionData>;

  fetchRequisitionAPSpecialists(id: number): Promise<IUserData[]>;
  assignRequisitionAPSpecialist(
    id: number,
    apSpecialist: number
  ): Promise<IPaymentRequisitionData>;

  fetchPaymentRequisitionApprovers(id: number): Promise<IUserData[]>;

  assignPaymentRequisitionApprover(
    id: number,
    approver: number
  ): Promise<IPaymentRequisitionData>;

  updatePaymentRequisitionOwner(
    id: number,
    owner: number
  ): Promise<IPaymentRequisitionData>;

  fetchPaymentRequisitionActivities(id: number): Promise<Transition[]>;

  //comments
  fetchPaymentRequisitionComments(
    requisitionId: number
  ): Promise<IPaymentRequisitionData[]>;

  fetchPaymentRequisitionComment(
    requisitionId: number,
    commentId: number
  ): Promise<IPaymentRequisitionData>;

  createPaymentRequisitionComment(
    requisitionId: number,
    comment: IPaymentRequisitionCommentData
  ): Promise<IPaymentRequisitionData>;

  updatePaymentRequisitionComment(
    requisitionId: number,
    comment: IPaymentRequisitionCommentData
  ): Promise<IPaymentRequisitionData>;

  deletePaymentRequisitionComment(
    requisitionId: number,
    commentId: number
  ): Promise<void>;

  addPaymentRequisitionCommentAttachments(
    requisitionId: number,
    commentId: number,
    attachments: IAttachmentData[]
  ): Promise<IPaymentRequisitionCommentData>;

  removePaymentRequisitionCommentAttachment(
    requisitionId: number,
    commentId: number,
    attachmentId: number
  ): Promise<void>;

  fetchPaymentRequisitionCommentsMentionableUsers(
    requisitionId: number
  ): Promise<IUserData[]>;

  //export payment requisition pdf
  exportPaymentRequisitionPdf(requisitionId: number): Promise<Blob>;
  exportPaymentRequisitions(
    params?: IPaymentRequisitionExportFilterParams
  ): Promise<Blob>;

  updateMultiplePaymentRequisitionOwner(
    owner: number,
    requisitions: number[]
  ): Promise<void>;
}

export const PAYMENT_REQUISITION_EXPORT_TIMEOUT_IN_MILLISECONDS = 30 * 1000;
